export class Produto
{
    public produtoId: string;
    public Codigo:string;
    public Nome:string;
    public CodTabela: string;
    public Descricao: string;
    public preco : number;
    public ativo: boolean;
    public tipo: string;
    public empresa: string;
    public qtdePorCaixa: number;

    public Assing(item)
    {
        this.produtoId = item.produtoId;
        this.Codigo = item.codigo;
        this.Nome = item.nome;
        this.CodTabela = item.codTabela;
        this.Descricao = item.descricao;
        this.preco = item.preco;
        this.ativo = item.ativo;
        this.tipo = item.tipo;
        this.empresa = item.empresa;
        this.qtdePorCaixa = item.qtdePorCaixa;
    }
}
